import type { ComponentProps } from 'react';

const BlacklistHospital = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_963_34957)">
        <path
          d="M26.223 18.4141H5.33398V26.8585H26.223V18.4141Z"
          fill="#8C98AB"
        />
        <path
          d="M28.8893 26.8594H2.66699V29.526H28.8893V26.8594Z"
          fill="#55657D"
        />
        <path
          d="M22.6675 6.41406H8.88965V26.8585H22.6675V6.41406Z"
          fill="#C5CCD6"
        />
        <path
          d="M12.9754 15.9668H11.2517V18.2664H12.9754V15.9668Z"
          fill="#55657D"
        />
        <path
          d="M12.9756 11.748H11.252V14.0477H12.9756V11.748Z"
          fill="#55657D"
        />
        <path
          d="M16.5418 15.9668H14.8181V18.2664H16.5418V15.9668Z"
          fill="#55657D"
        />
        <path
          d="M16.5418 11.748H14.8181V14.0477H16.5418V11.748Z"
          fill="#55657D"
        />
        <path
          d="M19.9886 15.9668H18.2649V18.2664H19.9886V15.9668Z"
          fill="#55657D"
        />
        <path
          d="M19.9886 11.748H18.2649V14.0477H19.9886V11.748Z"
          fill="#55657D"
        />
        <path
          d="M12.9754 19.9902H11.2517V22.2899H12.9754V19.9902Z"
          fill="#55657D"
        />
        <path
          d="M16.5418 19.9902H14.8181V22.2899H16.5418V19.9902Z"
          fill="#55657D"
        />
        <path
          d="M19.9886 19.9902H18.2649V22.2899H19.9886V19.9902Z"
          fill="#55657D"
        />
        <path
          d="M18.1505 24.0137H13.0684V27.8252H18.1505V24.0137Z"
          fill="#55657D"
        />
        <path
          d="M19.1458 6.65399C19.1458 8.50424 17.6459 10.0042 15.7956 10.0042C13.9453 10.0042 12.4454 8.50424 12.4454 6.65399C12.4454 4.80375 13.9453 3.30382 15.7956 3.30382C17.6459 3.30382 19.1458 4.80375 19.1458 6.65399Z"
          fill="#FEF7EB"
          stroke="#DE6257"
          stroke-width="0.888891"
        />
        <path
          d="M16.4861 4.92969H15.1055V8.26692H16.4861V4.92969Z"
          fill="#E06257"
        />
        <path
          d="M17.4173 5.95898H14.0801V7.33962H17.4173V5.95898Z"
          fill="#E06257"
        />
        <path
          d="M32.5882 18.2367L32.8072 17.5958L32.1629 17.3869C30.7418 16.9261 29.2516 15.826 28.0823 14.7898C27.5061 14.2791 27.0238 13.7985 26.6859 13.4459C26.5171 13.2697 26.3849 13.1261 26.2956 13.0273C26.2509 12.9779 26.217 12.9398 26.1947 12.9144L26.17 12.8862L26.1643 12.8797L26.1632 12.8784L26.1631 12.8783L26.163 12.8782L26.163 12.8782L25.561 12.1794L25.0864 12.9705L25.0708 12.9965C25.0706 12.9968 25.0705 12.997 25.0703 12.9973C24.8704 13.3278 22.8908 16.4725 19.8321 17.8652L19.3193 18.0988L19.4641 18.6433L20.1084 18.472C19.4641 18.6433 19.4642 18.6435 19.4642 18.6438L19.4644 18.6443L19.4648 18.6459L19.4661 18.6506L19.4703 18.666C19.4739 18.679 19.479 18.6973 19.4857 18.7206C19.4991 18.7671 19.5188 18.8337 19.545 18.9177C19.5975 19.0856 19.6762 19.3237 19.7833 19.6116C19.9971 20.186 20.3265 20.9655 20.7894 21.7825C21.7001 23.39 23.203 25.2744 25.4788 25.8709C25.6145 25.9069 25.7545 25.9381 25.8964 25.9649L26.0395 25.9919L26.1808 25.9567C29.8627 25.0408 31.292 22.0293 32.5882 18.2367Z"
          fill="#E06257"
          stroke="white"
          stroke-width="1.33333"
        />
        <path
          d="M31.958 18.0209C30.6591 21.8211 29.3251 24.4876 26.0205 25.3096C25.8925 25.2854 25.7682 25.2576 25.6494 25.2261V13.3374L25.6661 13.3096C25.6661 13.3096 28.8445 17.0114 31.958 18.0209Z"
          fill="#B43432"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.3888 21.7748L27.4815 22.7821L25.691 20.9525L23.9004 22.7821L22.9931 21.7748L23.8756 20.9256L24.77 20.0114L22.9473 18.1489L23.8884 17.2275L25.691 19.0701L27.4935 17.2275L28.4347 18.1489L26.6119 20.0114L27.5063 20.9256L28.3888 21.7748Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_963_34957">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BlacklistHospital;
